// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetRentListings = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        rents: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getRentListingsHandler: function() {

            /*
            **  Bind to the rents prop
            **  @prop: @here
            **  @service: VueFire
            */

            this.$bind('rents', propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').where('meta.deleted_at', '==', null).orderBy('attributes.term_dates.starting_at', 'desc'));

        }

    }

}